import React from 'react'
import { IconButton, InputAdornment, Stack, SvgIcon, SxProps, TextField } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { ReactComponent as CloseIcon } from '../../../assets/images/Close.svg'
import { ReactComponent as SearchIcon } from '../../../assets/images/search-icon.svg'

const FIELD_HEIGHT = 44

export type SearchInputProps = {
    value: string
    onChange: (value: string) => void
    placeholder?: string
    label?: string
    width?: number | string
    sx?: SxProps<Theme>
}

export const SearchInput = ({
    value,
    onChange,
    placeholder = 'Search',
    label = 'Search',
    width = 349,
    sx = [],
}: SearchInputProps) => (
    <TextField
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        inputProps={{ 'aria-label': label }}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <Stack direction="row" alignItems="center" gap={0.5}>
                        {!!value && (
                            <IconButton
                                size="small"
                                aria-label="Clear search"
                                onClick={() => onChange('')}
                                // Same token as the search icon beside it. Without one this inherits
                                // MUI's default action.active, which stays dark in both themes.
                                sx={{ p: 0.25, color: 'figma.grayscale.tier2', '&:hover': { color: 'figma.primary' } }}
                            >
                                <SvgIcon
                                    component={CloseIcon}
                                    inheritViewBox
                                    sx={{ fontSize: '16px' }}
                                    color="inherit"
                                />
                            </IconButton>
                        )}
                        <SvgIcon
                            component={SearchIcon}
                            inheritViewBox
                            sx={{ fontSize: '16px', color: 'figma.grayscale.tier2' }}
                        />
                    </Stack>
                </InputAdornment>
            ),
        }}
        sx={[
            {
                width: { xs: '100%', md: width },
                '& .MuiOutlinedInput-root': {
                    height: FIELD_HEIGHT,
                    borderRadius: '12px',
                    backgroundColor: 'figma.grayscale.contentWrapper',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'figma.grayscale.stroke',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'figma.grayscale.tier5',
                },
                // MUI sizes inputs from body1, which is 18px here.
                '& .MuiInputBase-input': {
                    py: 1.25,
                    fontFamily: 'acumin-pro',
                    fontWeight: 400,
                    fontSize: '14px',
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    />
)

export default SearchInput
